import React, { useEffect, useState } from 'react'
import BuildingMilestones from './BuildingMilestones'
import DailyChecklist from './DailyChecklist'
import EdesMilestoneTracker from './EdesMilestoneTracker'

const Operations = ({ defaultView = 'milestones' }) => {
  const [view, setView] = useState(defaultView)

  useEffect(() => {
    setView(defaultView)
  }, [defaultView])

  return (
    <div className="page">
      <div className="page-header">
        <h2>Operations</h2>
        <p>Select an operations tool to continue.</p>
      </div>
      <div className="actions" style={{ justifyContent: 'flex-start', flexWrap: 'wrap', marginBottom: 16 }}>
        <button
          className={`btn ${view === 'milestones' ? 'primary' : ''}`}
          onClick={() => setView('milestones')}
        >
          Building Milestones
        </button>
        <button
          className={`btn ${view === 'checklist' ? 'primary' : ''}`}
          onClick={() => setView('checklist')}
        >
          Daily Checklist
        </button>
        <button
          className={`btn ${view === 'edes-milestones' ? 'primary' : ''}`}
          onClick={() => setView('edes-milestones')}
        >
          Edes Milestones
        </button>
      </div>
      {view === 'milestones' && <BuildingMilestones />}
      {view === 'checklist' && <DailyChecklist />}
      {view === 'edes-milestones' && <EdesMilestoneTracker />}
    </div>
  )
}

export default Operations
